import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const API_URL =
  "https://adinsinternational.com/websitebackend/factory_image_api.php";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

export default function FactoryImages() {
  const [images, setImages] = useState<string[]>([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loading, setLoading] = useState(true);

  // ── FETCH IMAGES ───────────────────────────────────────────
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(API_URL);
        const json = await res.json();
        if (json.status === "success") {
          const urls = json.data.flatMap(
            (item: { image_urls: string[] }) => item.image_urls
          );
          setImages(urls);
        }
      } catch (err) {
        console.error("Failed to load factory images:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-20">
        <span className="animate-pulse text-xl">Loading images…</span>
      </div>
    );
  }

  if (!images.length) {
    return (
      <div className="text-center py-20 text-red-600">
        No factory images found.
      </div>
    );
  }

  return (
    <div className="bg-[#fdf5ec] container mx-auto px-6 py-20">
      <h2 className="text-5xl font-bold text-center mb-10">
        Inside Our <span className="text-[#f98715]">Factory</span>
      </h2>

      <Carousel
        responsive={responsive}
        ssr
        infinite
        autoPlay
        autoPlaySpeed={2500}
        keyBoardControl
        showDots={false}
        arrows={false}
        slidesToSlide={1}
        beforeChange={(next) => setCurrentSlide(next)}
        containerClass="carousel-container"
        itemClass="carousel-item-padding-10-px"
        customTransition="transform 0.5s ease-in-out"
      >
        {images.map((url, index) => {
          // ── ZOOM LOGIC ──────────────────────────────────────
          let scale = 1;
          if (index >= currentSlide && index < currentSlide + 4) {
            // spotlight the 2nd visible item
            if (index === currentSlide + 1) scale = 1.1;
          }

          return (
            <div
              key={index}
              className="p-4 transition-transform duration-500 ease-in-out"
              style={{ transform: `scale(${scale})` }}
            >
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <img
                  src={url}
                  alt={`Factory view ${index + 1}`}
                  className="w-full h-72 object-cover"
                />
              </div>
            </div>
          );
        })}
      </Carousel>
    </div>
  );
}
